import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useMediaQuery, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { PersonIcon } from '@skatteetaten/ds-icons';
import { TopBannerInternalActionMenu } from '../TopBannerInternalActionMenu/index.esm.js';
import { TopBannerSkipLink } from '../TopBannerSkipLink/index.esm.js';
import 'react-i18next';
import '@floating-ui/react';
import '@skatteetaten/ds-buttons';
import './styles.css';


const getTopBannerInternalHideLogoOnMobileDefault = ()=>false;

var defaultLogo = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0%2032H32V0H0V32ZM31.2647%2031.2647H0.735294V0.735294H31.2647V31.2647ZM15.6066%2022.0333C10.2389%2022.0333%205.88599%2019.662%205.88599%2016.7318H5.88966C5.88966%2013.8054%2010.2316%2011.4341%2015.5919%2011.4304V8.81641C17.2536%208.81641%2018.8382%209.04435%2020.2058%209.44508L15.6139%2014.0701V16.7318L20.2058%2012.0591C23.2573%2012.9524%2025.3308%2014.7098%2025.3308%2016.7318C25.3308%2019.6583%2020.9742%2022.0333%2015.6066%2022.0333Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var styles = {
    "constructionBand": "TopBannerInternal-module_constructionBand__mznOb",
    "constructionBandTitle": "TopBannerInternal-module_constructionBandTitle__A0Niq",
    "skipLink": "TopBannerInternal-module_skipLink__3nFYb",
    "topBanner": "TopBannerInternal-module_topBanner__dZO9o",
    "titleAndDescriptionContainer": "TopBannerInternal-module_titleAndDescriptionContainer__hDi6K",
    "logoAndTitleLink": "TopBannerInternal-module_logoAndTitleLink__xr3lM",
    "logoImage": "TopBannerInternal-module_logoImage__MFzI-",
    "childrenAndUserContainer": "TopBannerInternal-module_childrenAndUserContainer__bN81C",
    "userContainer": "TopBannerInternal-module_userContainer__VReUt",
    "userContainerIcon": "TopBannerInternal-module_userContainerIcon__j-KLA",
    "userContainerName": "TopBannerInternal-module_userContainerName__iwTuK"
};

const TopBannerInternal = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), classNames, lang, 'data-testid': dataTestId, logo, logoHref, logoAltText, skipLink, user, children, title, description, constructionBandTitle, onLogoClick, isUnderConstruction, hideLogoOnMobile = getTopBannerInternalHideLogoOnMobileDefault() }, ref)=>{
    const isDesktop = useMediaQuery('(min-width: 1024px)');
    const isMobile = !useMediaQuery('(min-width: 640px)');
    const shouldHideLogo = isMobile && hideLogoOnMobile;
    const showChildrenAndUserContainer = children || user && isDesktop;
    return /*#__PURE__*/ jsxs("header", {
        ref: ref,
        id: id,
        lang: lang,
        "data-testid": dataTestId,
        className: className,
        children: [
            /*#__PURE__*/ jsx(TopBannerSkipLink, {
                className: styles.skipLink,
                target: skipLink?.target,
                shadowRootNode: skipLink?.shadowRootNode,
                children: skipLink?.text
            }),
            isUnderConstruction && /*#__PURE__*/ jsx("div", {
                className: styles.constructionBand,
                children: /*#__PURE__*/ jsx("div", {
                    className: styles.constructionBandTitle,
                    children: constructionBandTitle ?? 'test'
                })
            }),
            /*#__PURE__*/ jsxs("div", {
                className: styles.topBanner,
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: styles.titleAndDescriptionContainer,
                        children: [
                            /*#__PURE__*/ jsxs("a", {
                                className: styles.logoAndTitleLink,
                                href: logoHref,
                                onClick: onLogoClick,
                                children: [
                                    !shouldHideLogo && /*#__PURE__*/ jsx("img", {
                                        className: `${styles.logoImage} ${classNames?.logo ?? ''}`.trim(),
                                        src: logo ?? defaultLogo,
                                        alt: '',
                                        "aria-hidden": true
                                    }),
                                    title && /*#__PURE__*/ jsx("span", {
                                        children: title
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ jsx("span", {
                                children: description
                            })
                        ]
                    }),
                    showChildrenAndUserContainer && /*#__PURE__*/ jsxs("div", {
                        className: `${styles.childrenAndUserContainer} ${classNames?.childrenAndUserContainer ?? ''}`.trim(),
                        children: [
                            children,
                            user && /*#__PURE__*/ jsxs("div", {
                                className: styles.userContainer,
                                children: [
                                    /*#__PURE__*/ jsx(PersonIcon, {
                                        className: styles.userContainerIcon
                                    }),
                                    /*#__PURE__*/ jsx("span", {
                                        className: styles.userContainerName,
                                        children: user
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
TopBannerInternal.displayName = 'TopBannerInternal';
TopBannerInternal.ActionMenu = TopBannerInternalActionMenu;
TopBannerInternal.ActionMenu.displayName = 'TopBannerInternal.ActionMenu';

export { TopBannerInternal, getTopBannerInternalHideLogoOnMobileDefault };
